(() => {
  'use strict';
  const policy = document.getElementById('ov-custom-commerce-policy');
  if (!policy) return;
  const config = JSON.parse(policy.textContent);
  if (config.enabled) return;
  const handles = new Set(['drum-lithophane-lamp', 'column-lithophane-lamp']);
  const variants = new Set(config.variantIds.map(String));
  const unavailable = 'Custom ordering is temporarily unavailable. You can still preview your design. No photo has been submitted for production and no Custom order has been created.';
  const cartMessage = 'Custom ordering is temporarily unavailable. Remove the Custom lamp from your cart to check out with other items. Your cart has not been changed.';
  const nativeFetch = window.fetch.bind(window);
  const checkoutSelector = '[name="checkout"], a[href^="/checkout"], a[href*="/checkouts/"], .additional-checkout-buttons, shopify-accelerated-checkout-cart';
  const controlled = new Map();
  const consumedEvidence = new WeakSet();
  let cartKind = classify(config.cartLineVariantIds), scheduled = false, refreshSerial = 0;
  function classify(ids) {
    if (!Array.isArray(ids) || ids.some(id => !/^\d+$/.test(String(id)))) return 'UNKNOWN';
    const custom = ids.filter(id => variants.has(String(id))).length;
    return custom ? (custom === ids.length ? 'CUSTOM_ONLY' : 'MIXED') : 'READY_MADE_ONLY';
  }
  function acceptCart(cart) {
    if (!Array.isArray(cart?.items)) return false;
    const kind = classify(cart.items.map(item => item.variant_id || item.id));
    if (kind === 'UNKNOWN') return false;
    cartKind = kind; return true;
  }
  function readRenderedEvidence() {
    document.querySelectorAll('[data-ov-cart-evidence]').forEach(node => {
      if (consumedEvidence.has(node)) return;
      consumedEvidence.add(node);
      try {
        const kind = classify(JSON.parse(node.textContent).variantIds);
        if (kind !== 'UNKNOWN') { cartKind = kind; refreshSerial++; }
      } catch { /* Keep the last proven cart classification. */ }
    });
  }
  const path = url => new URL(url, location.href).pathname;
  const cartMutation = url => /\/cart\/(add|change|update|clear)(\.js)?$/.test(path(url));
  const cartAdd = url => /\/cart\/add(\.js)?$/.test(path(url));
  function customBody(body) {
    if (body instanceof FormData || body instanceof URLSearchParams) {
      return [...body.entries()].some(([key, value]) => /^(id|items\[\d+\]\[id\])$/.test(key) && variants.has(String(value)));
    }
    if (typeof body === 'string') {
      try { return customBody(JSON.parse(body)); } catch { return customBody(new URLSearchParams(body)); }
    }
    return Boolean(body && (variants.has(String(body.id)) || body.items?.some(item => variants.has(String(item.id)))));
  }
  function announce(message) {
    let note = document.getElementById('ov-custom-commerce-message');
    if (!note) {
      note = document.createElement('p'); note.id = 'ov-custom-commerce-message';
      note.setAttribute('role', 'alert'); note.setAttribute('tabindex', '-1'); note.dataset.ovContainmentNotice = '';
      (document.getElementById('MainContent') || document.body).prepend(note);
    }
    note.textContent = message; note.hidden = false; note.focus({preventScroll:true});
  }
  function update() {
    readRenderedEvidence();
    const cartBlocked = cartKind !== 'READY_MADE_ONLY';
    document.documentElement.dataset.ovCartKind = cartKind;
    document.documentElement.toggleAttribute('data-ov-custom-cart-blocked', cartBlocked);
    document.querySelectorAll('[data-ov-pdp-purchase] [data-ov-payment-help]').forEach(note => {
      if (note.closest('[data-ov-pdp-purchase]').dataset.draftCheckout === 'true') return;
      if (note.textContent !== 'Custom purchasing is temporarily unavailable.') note.textContent = 'Custom purchasing is temporarily unavailable.';
    });
    document.querySelectorAll('[data-ov-atelier]').forEach(root => {
      if (!handles.has(root.dataset.productHandle) || root.dataset.customDraftCheckout === 'true') return;
      // Keep the existing renderer local while the incident gate is closed.
      root.removeAttribute('data-private-storage-endpoint');
      if (root.dataset.mode !== 'preview') root.dataset.mode = 'preview';
      const review = root.querySelector('[data-ov-preview-review]');
      if (review) {
        const loading = root.querySelector('[data-customizer-loading]');
        const blocked = !root.querySelector('[data-image-property]')?.value || root.dataset.webglStatus !== 'ready' || root.dataset.cropEditing === 'true' || Boolean(loading && !loading.hidden);
        if (review.disabled !== blocked) review.disabled = blocked;
      }
      root.querySelectorAll('[data-custom-atc], [data-sticky-atc]').forEach(button => {
        if (!button.disabled) button.disabled = true;
        if (button.textContent !== 'Custom ordering temporarily unavailable') button.textContent = 'Custom ordering temporarily unavailable';
      });
      root.querySelectorAll('[data-cart-link]').forEach(link => { if (!link.hidden) link.hidden = true; });
      const status = root.querySelector('[data-customizer-status]');
      if (status && /storage is (not configured|unavailable)/i.test(status.textContent)) status.textContent = 'Preview ready on this device. Custom ordering is temporarily unavailable.';
      const cartStatus = root.querySelector('[data-cart-status]');
      if (cartStatus && cartStatus.textContent !== 'Preview only. Custom purchasing is temporarily unavailable.') cartStatus.textContent = 'Preview only. Custom purchasing is temporarily unavailable.';
      const roomCaption = root.querySelector('[data-room-caption]');
      if (roomCaption?.textContent.includes('your selected option applies to the order')) roomCaption.textContent = roomCaption.textContent.replace('your selected option applies to the order', 'preview only; ordering is unavailable');
      const cropNote = root.querySelector('[data-crop-note]');
      if (cropNote?.textContent.includes('until you save')) cropNote.textContent = cropNote.textContent.replace('until you save', 'until you apply this preview');
    });
    document.querySelectorAll(checkoutSelector).forEach(element => {
      if (cartBlocked) {
        if (!controlled.has(element)) controlled.set(element, {disabled:element.hasAttribute('data-ov-custom-checkout-held') ? false : element.disabled, inert:element.inert});
        if ('disabled' in element && !element.disabled) element.disabled = true;
        if (!element.inert) element.inert = true;
      } else if (controlled.has(element)) {
        const previous = controlled.get(element);
        if ('disabled' in element) element.disabled = previous.disabled;
        element.inert = previous.inert; controlled.delete(element);
        element.removeAttribute('data-ov-custom-checkout-held');
      }
    });
    document.querySelectorAll('[data-ov-custom-cart-notice]').forEach(note => { if (note.hidden !== !cartBlocked) note.hidden = !cartBlocked; });
  }
  function schedule() { if (!scheduled) { scheduled = true; queueMicrotask(() => { scheduled = false; update(); }); } }
  async function refreshCart() {
    const serial = ++refreshSerial;
    try {
      const response = await nativeFetch(config.cartUrl, {credentials:'same-origin', cache:'no-store'});
      if (!response.ok) throw new Error('Cart unavailable');
      const cart = await response.json();
      if (serial === refreshSerial) acceptCart(cart);
    } catch { /* A failed refresh is not evidence that the known cart changed. */ }
    update();
  }
  window.fetch = async function(input, init) {
    const url = typeof input === 'string' || input instanceof URL ? String(input) : input.url;
    let body = init?.body;
    if (cartAdd(url) && body === undefined && input instanceof Request) {
      const copy = input.clone();
      body = (copy.headers.get('content-type') || '').includes('multipart/form-data') ? await copy.formData() : await copy.text();
    }
    if (cartAdd(url) && customBody(body)) {
      announce(unavailable);
      return new Response(JSON.stringify({status:422,message:unavailable,description:unavailable}), {status:422,headers:{'Content-Type':'application/json'}});
    }
    const response = await nativeFetch(input, init);
    if (response.ok && cartMutation(url)) {
      // add.js returns only added lines; change/update/clear return the full cart.
      let fullCart = false;
      if (!cartAdd(url)) { try { fullCart = acceptCart(await response.clone().json()); } catch {} }
      if (fullCart) { refreshSerial++; update(); } else await refreshCart();
    }
    return response;
  };
  const open = XMLHttpRequest.prototype.open, send = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function(method, url, ...rest) { this.ovCartUrl = String(url); return open.call(this, method, url, ...rest); };
  XMLHttpRequest.prototype.send = function(body) {
    if (this.ovCartUrl && cartAdd(this.ovCartUrl) && customBody(body)) {
      announce(unavailable); this.abort(); this.dispatchEvent(new Event('error')); return;
    }
    if (this.ovCartUrl && cartMutation(this.ovCartUrl)) this.addEventListener('load', refreshCart, {once:true});
    return send.call(this, body);
  };
  document.addEventListener('submit', event => {
    const cartBlocked = cartKind !== 'READY_MADE_ONLY';
    const form = event.target;
    const action = form.getAttribute('action') || '';
    if ((cartAdd(action) && customBody(new FormData(form))) || (cartBlocked && (event.submitter?.name === 'checkout' || /\/checkouts?\b/.test(path(action))))) {
      event.preventDefault(); event.stopImmediatePropagation(); announce(cartBlocked ? cartMessage : unavailable);
    }
  }, true);
  document.addEventListener('click', event => {
    const review = event.target.closest('[data-ov-preview-review]');
    if (review && !review.disabled) {
      event.preventDefault(); event.stopImmediatePropagation();
      const root = review.closest('[data-ov-atelier]');
      const source = root.querySelector('[data-source-preview]');
      const canvas = root.querySelector('[data-ov-review-canvas]');
      const scale = Math.min(640 / source.width, 640 / source.height, 1);
      canvas.width = Math.max(1, Math.round(source.width * scale));
      canvas.height = Math.max(1, Math.round(source.height * scale));
      canvas.getContext('2d').drawImage(source, 0, 0, canvas.width, canvas.height);
      root.querySelector('[data-ov-review-option]').textContent = root.querySelector('[data-bound-variant]').selectedOptions[0].dataset.title + ' · Preview only · Ordering unavailable';
      root.querySelector('[data-demo-dialog]').showModal();
      return;
    }
    const cartBlocked = cartKind !== 'READY_MADE_ONLY';
    const link = event.target.closest('a[href]');
    const target = event.target.closest('[data-custom-atc], [data-sticky-atc]');
    if ((target && target.closest('[data-ov-atelier]')?.dataset.customDraftCheckout !== 'true') || (cartBlocked && (event.target.closest('[name="checkout"], .additional-checkout-buttons, shopify-accelerated-checkout-cart') || (link && /\/checkouts?\b/.test(path(link.href)))))) {
      event.preventDefault(); event.stopImmediatePropagation(); announce(cartBlocked ? cartMessage : unavailable);
    }
  }, true);
  document.addEventListener('ov:attachment', schedule, true);
  new MutationObserver(schedule).observe(document.documentElement,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','data-cart-state','data-persistence-status','data-webgl-status','data-crop-editing']});
  window.addEventListener('pageshow', refreshCart);
  window.addEventListener('focus', refreshCart);
  update();
})();
